'use strict';
import React from 'react';
import CheckoutCart from 'checkout/cart/checkoutCart';
import CheckoutTotals from 'checkout/steps/checkoutTotals';
import CheckoutPreviewAddress from 'checkout/preview/checkoutPreviewAddress';
import CheckoutPreviewTotal from 'checkout/preview/checkoutPreviewTotal';

export default class CheckoutPreview extends React.Component {
    doOrder(e) {
        e.preventDefault();
        this.props.actions.doCheckout();
    }
    goBack(e) {
        e.preventDefault();
        this.props.actions.showCheckout();
    }
    renderLoading() {
        return (
            <div className="checkout__preview checkout__preview--loading">
                Lade ...
            </div>
        );
    }
    changeComment(event) {
        this.props.actions.editComment(event.target.value);
    }
    render() {
        let {cart, actions} = this.props;
        if (cart.get('loading')) {
            return this.renderLoading();
        }
        let paymentInfo = this.props.cart.get('paymentInfo').find(item => item.get('name') === this.props.cart.get('selected_payment'));
        return (
            <div className="checkout checkout__preview">
                <div className="checkout__top">
                    <CheckoutPreviewAddress cart={cart} />
                    <CheckoutTotals cart={cart} actions={actions} />
                </div>
                <div className="preview__payment">
                    <div className="payment__headline">Versand / Zahlung</div>
                    <div className="payment__description">{paymentInfo.get('description')}</div>
                </div>

                <CheckoutCart cart={cart} readOnly={true} actions={actions} />
                <div className="preview__footer">
                    <div className="preview__comment">
                        <form>
                            <textarea value={cart.getIn(['checkout', 'comment'])} onChange={::this.changeComment} placeholder="Hier können Sie uns eine Nachricht zu Iherer Bestelllung hinterlassen" id="comment"></textarea>
                        </form>
                    </div>
                    <CheckoutPreviewTotal cart={cart} />
                </div>
                <form>
                    <div className="preview__terms">
                        <div className="terms__row">
                            <div className="row__label">Mit Klick auf "Zahlungspflichtig bestellen" akzpetieren Sie unsere <a target="_blank" href="/agb">Allgemeinen Geschäftsbedingeungen</a> und unsere <a target="_blank" href="/widerruf">Wiederrufbelehrung</a></div>
                        </div>
                    </div>

                    <div className="preview__actions">
                        <button onClick={::this.doOrder} className="btn">Zahlungspflichtig bestellen</button>
                        <button onClick={::this.goBack} className="btn btn--border">Zurück</button>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/preview/checkoutPreview.jsx